module.exports = __webpack_public_path__ + "static/ellen-armstrong-pic-3-5edf9fcfb04a502f511ffa185647d335.jpg";